import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import { useParams } from "react-router-dom";
import { useCompanyAssigned } from "./CompanyAssignedContext";

const Table = ({ columns, data, title, onRowClicked, keyField = 'authCode' }) => {
  const [isMobile, setIsMobile] = useState(false);

  // 1) Detectar tamaño de pantalla
  useEffect(() => {
    const handleResize = () => {
      setIsMobile(window.innerWidth <= 768);
    };
    window.addEventListener("resize", handleResize);
    handleResize();
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  // 2) Obtener el nit de la URL y el contexto
  const { nit } = useParams();

  // 4) Componente expandido para filas en móvil
  const ExpandedComponent = ({ data }) => (
    <div style={{ padding: "10px", backgroundColor: "#f9f9f9" }}>
      {Object.keys(data).map((key, index) => (
        <p key={index} style={{ fontFamily: "Roboto, sans-serif" }}>
          <b>{key}:</b> {data[key]}
        </p>
      ))}
    </div>
  );

  // 5) Estilos personalizados, usando themeColor en headCells
  const customStyles = {
    table: {
      style: {
        width: "100%",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
      },
    },
    headCells: {
      style: {
        backgroundColor: 'var(--theme-company)',
        color: "white",
        fontWeight: "bold",
        textAlign: "center",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        padding: "12px",
        minWidth: "120px",
        whiteSpace: "nowrap",
        fontSize: "0.875rem",
      },
    },
    cells: {
      style: {
        whiteSpace: "normal",
        overflow: "visible",
        textOverflow: "unset",
        textAlign: "center",
        wordWrap: "break-word",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        padding: "10px",
        fontSize: "0.875rem",
      },
    },
    rows: {
      style: {
        minHeight: "56px",
        textAlign: "center",
        fontFamily: "Roboto, Helvetica, Arial, sans-serif",
        fontSize: "0.875rem",
      },
    },
  };

  return (
    <DataTable
      keyField={keyField}
      title={title}
      columns={columns}
      data={data}
      pagination
      responsive
      highlightOnHover
      striped
      expandableRows={isMobile}
      expandableRowsComponent={ExpandedComponent}
      customStyles={customStyles}
      onRowClicked={onRowClicked}
      paginationPerPage={5}
      paginationRowsPerPageOptions={[5, 10, 15, 20]}
      paginationComponentOptions={{
        rowsPerPageText: "Filas por página:",
        rangeSeparatorText: "de",
      }}
      noDataComponent={
        <div style={{ padding: "20px", textAlign: "center", fontFamily: "Roboto, sans-serif" }}>
          No hay registros disponibles
        </div>
      }
    />
  );
};

export default Table;
